/* eslint-disable arrow-return-style/arrow-return-style */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { hasAtLeast, isNonNullish } from 'remeda'
import type {
  ComplementaryProductsMetafieldReferenceEdge,
  RelatedProductsProducts,
  SeasonID,
  TransformedProduct,
  UseProductsProductEdge,
} from '@velasca/types'
import { getProductCardImage } from './getProductCardImage'
import { isMediaImage } from './isMediaImage'
import { isSeason } from './isSeason'

const isUseProductsProductsEdge = (obj: any): obj is UseProductsProductEdge =>
  obj?.hasOwnProperty('node')

const isComplementaryProductsMetafieldReferenceEdge = (
  obj: any,
): obj is ComplementaryProductsMetafieldReferenceEdge =>
  obj?.hasOwnProperty('node')

/**
 * TODO: probabilmente questa funzione è da separare in più funzioni e comporre le parti comuni. Ci sono troppi if else che non ci sarebbero usando della composition.
 */
export const transformProductsSliderData = (
  products:
    | UseProductsProductEdge[]
    | ComplementaryProductsMetafieldReferenceEdge[]
    | RelatedProductsProducts,
  swapImages?: boolean,
): TransformedProduct[] => {
  if (!products) {
    return []
  }

  return products.map((product) => {
    // Qui è tutto sbagliato che i tipi siano determinati. Essendo campi derivanti da una query graphQL, potrebbero sempre essere null. Ma Shopify li definisce come sempre presenti...
    const {
      id,
      title,
      isGiftCard = false,
      handle,
      productType,
      media,
      variants,
      color,
      colorShort,
      materialShort,
      material,
      priceRange,
      compareAtPriceRange,
      customProductType,
      staffPickIconID,
      isNew,
      frontImageIndex,
      hoverImageIndex,
      collectionBrandID,
      collectionBrandName,
      seasonID,
      seasonName,
      jolly,
      sole,
    } = isUseProductsProductsEdge(product) ||
    isComplementaryProductsMetafieldReferenceEdge(product)
      ? product.node
      : product

    let reviewsAverage
    let reviewsCount

    if (isUseProductsProductsEdge(product)) {
      reviewsAverage = product.node.reviewsAverage
      reviewsCount = product.node.reviewsCount
    }

    const flatImages = media.edges
      .map(({ node }) => node)
      .filter(isMediaImage)
      .map(({ image }) => image?.url)
      .filter(isNonNullish)
    const img = getProductCardImage({
      images: flatImages,
      customProductType: customProductType?.value
        ? parseInt(customProductType.value)
        : undefined,
      frontImageIndex: frontImageIndex?.value
        ? parseInt(frontImageIndex.value)
        : undefined,
      hoverImageIndex: hoverImageIndex?.value
        ? parseInt(hoverImageIndex.value)
        : undefined,
      areCollectionCardImagesWornApparel: swapImages,
    })

    const sizes =
      variants?.edges.map(
        (
          { node: { id, selectedOptions, quantityAvailable } },
          index,
          entireArray,
        ) => {
          return {
            id: id.split('/').at(-1) || '',
            gid: id,
            quantityAvailable: quantityAvailable || 0,
            name: hasAtLeast(entireArray, 2)
              ? selectedOptions[0]?.value || ''
              : '',
          }
        },
      ) || []

    const transformedProduct = {
      gid: id,
      id: id.split('/').at(-1) || '',
      title,
      handle,
      isGiftCard,
      customProductType: customProductType?.value,
      productType,
      collectionBrandID: collectionBrandID?.value,
      reviews: {
        average: parseInt(reviewsAverage?.value || '0'),
        label: '', // non la so
        count: parseInt(reviewsCount?.value || '0'),
      },
      sizes,
      variants: [
        {
          gid: id,
          id: id.split('/').at(-1) || '',
          handle,
          name: title,
          price: {
            max: parseFloat(priceRange.maxVariantPrice.amount || '0'),
            min: parseFloat(priceRange.minVariantPrice.amount || '0'),
          },
          compareAtPrice: {
            max: parseFloat(compareAtPriceRange.maxVariantPrice.amount || '0'),
            min: parseFloat(compareAtPriceRange.minVariantPrice.amount || '0'),
          },
          img,
          description: {
            bold: colorShort?.value ?? color?.value ?? null,
            thin: materialShort?.value ?? material?.value ?? null,
          },
          staffPickIconID: staffPickIconID?.value || '',
          isNew: isNew?.value === 'true',
          collectionBrandName: collectionBrandName?.value || undefined,
          seasonID:
            seasonID?.value && isSeason(parseInt(seasonID.value))
              ? (parseInt(seasonID.value) as SeasonID)
              : undefined,
          seasonName: seasonName?.value || undefined,
          jolly: jolly?.value || undefined,
          sole_tag: sole?.value ? { value: sole.value } : undefined,
        },
      ],
    }

    return transformedProduct
  })
}
